// extracted by mini-css-extract-plugin
export default {"offersHeader":"styles_offersHeader__PB6PZ","title":"styles_title__YP1gw","description":"styles_description__UZVQP"};